<script>

import {FwbAccordion, FwbAccordionContent, FwbAccordionHeader, FwbAccordionPanel} from "flowbite-vue";

export default {
    components: {
        FwbAccordionContent,
        FwbAccordionHeader,
        FwbAccordionPanel,
        FwbAccordion
    },
    props: {
        faqItems: {
            type: Object,
            default: () => {
            }
        }
    }
}
</script>

<template>
    <section title="frequently asked questions" class="py-2">
        <div class="mx-auto px-4 sm:py-16">
            <h2 class="mb-8 text-4xl font-extrabold text-gray-900 dark:text-white">Frequently asked
                questions</h2>
            <div
                class="pt-8 text-left border-t border-gray-200 dark:border-gray-700">
                <!-- FAQ Section: General -->
                <fwb-accordion>
                    <template v-for="(questionCategory, index) in faqItems">

                        <fwb-accordion-panel>
                            <fwb-accordion-header>{{ questionCategory.question }}</fwb-accordion-header>
                            <fwb-accordion-content>
                                <div>
                                    <p class="mb-2 text-gray-500 dark:text-gray-400">
                                        {{ questionCategory.answer }}
                                    </p>
                                </div>
                            </fwb-accordion-content>
                        </fwb-accordion-panel>

                    </template>
                </fwb-accordion>
            </div>
        </div>
    </section>
</template>

<style scoped>

</style>
